import { MainNavMenuAsButton, MainNavMenuLink } from "@compono/ui";
import { UserGroupOutlineIcon } from "@compono/ui-icons";

import { ShowIf, ShowIfAny } from "~/auth-layer";

export const PeopleNav = () => {
  return (
    <ShowIfAny
      allowedTo={[
        "employers.view",
        "organisations.edit",
        "product.engageAdmin",
        "product.developAdmin",
      ]}
    >
      <MainNavMenuAsButton icon={UserGroupOutlineIcon} label="People">
        <ShowIf allowedTo="employers.view">
          <MainNavMenuLink href={`/users`} label="Users" />
        </ShowIf>
        <ShowIfAny allowedTo={["product.engageAdmin", "product.developAdmin"]}>
          <MainNavMenuLink href={`/groups`} label="Groups" />
        </ShowIfAny>
        <ShowIf allowedTo="organisations.edit">
          <MainNavMenuLink href={`/settings`} label="Organisation structure" />
        </ShowIf>
      </MainNavMenuAsButton>
    </ShowIfAny>
  );
};
